module.exports = __webpack_public_path__ + "img/logo_navbar.5fd67801.png";